import { FC, HTMLAttributes, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Form } from 'antd';

import {
	CreateArbitrationSourceForm,
	CreateBloggerSourceForm,
	CreateWebsiteSourceForm,
	ESourceTypes,
	ISource,
	useSourceSlice,
} from 'entities/Source';
import { useTrans } from 'shared/hooks';
import { RadioGroup } from 'shared/ui';

interface ICreateSourceFormProps extends HTMLAttributes<HTMLDivElement> {
	isOnboarding?: boolean;
	source?: ISource;
}

export const CreateSourceForm: FC<ICreateSourceFormProps> = ({ className, isOnboarding, source, ...props }) => {
	const { t } = useTranslation();
	const { sourceTypes } = useTrans();
	const { type, setType, websiteValues } = useSourceSlice();

	const isLoading = false;

	const onBeforeUnload = useCallback(
		(e: BeforeUnloadEvent) => {
			if (websiteValues.name) {
				e.preventDefault();
				return '';
			}
		},
		[websiteValues],
	);

	useEffect(() => {
		window.addEventListener('beforeunload', onBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', onBeforeUnload);
		};
	}, [websiteValues, onBeforeUnload]);

	useEffect(() => {
		return () => {
			setType('' as ESourceTypes);
		};
	}, []); // eslint-disable-line

	return (
		<Flex {...props} vertical gap={24} className={className}>
			<Form.Item layout="vertical" label={t('Тип площадки')} required>
				<RadioGroup
					items={[
						{ label: sourceTypes[ESourceTypes.WEBSITE], value: ESourceTypes.WEBSITE },
						{ label: sourceTypes[ESourceTypes.BLOGGER], value: ESourceTypes.BLOGGER },
						{ label: sourceTypes[ESourceTypes.ARBITRATION], value: ESourceTypes.ARBITRATION },
					]}
					name="type"
					onChange={(e) => setType(e.target.value)}
					value={type}
					disabled={isLoading || !!source?.uuid}
				/>
			</Form.Item>

			{type === ESourceTypes.WEBSITE && <CreateWebsiteSourceForm isOnboarding={isOnboarding} source={source} />}
			{type === ESourceTypes.BLOGGER && <CreateBloggerSourceForm isOnboarding={isOnboarding} source={source} />}
			{type === ESourceTypes.ARBITRATION && <CreateArbitrationSourceForm isOnboarding={isOnboarding} source={source} />}
		</Flex>
	);
};
